<template>
    <b-row class="register-block p-4">
        <div class="d-sm-flex">
            <h2 class="register-title mr-4">Cadastre-se</h2>
            <div class="register-typePerson ml-sm-4 my-3 my-sm-0">
                <div class="d-flex">
                    <div class="register-styled_radio">
                        <input id="type_person_pf" name="type_person" type="radio" v-model="person.type" value="PF">
                        <label for="type_person_pf">Pessoa Física</label>
                    </div>
                    <div class="register-styled_radio">
                        <input id="type_person_pj" name="type_person" type="radio" v-model="person.type" value="PJ">
                        <label for="type_person_pj">Pessoa Jurídica</label>
                    </div>
                </div>
            </div>
        </div>
        <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
            <form action="#" method="post" name="register_form" class="form_default mt-4" @submit.prevent="handleSubmit(onSubmit)">
                <fieldset>
                    <legend class="register-data-title">Dados de login</legend>
                    <b-row>
                        <div class="col-sm-6 col-lg-3">
                            <ValidationProvider name="e-mail" rules="required|email" vid="email" slim v-slot="{ errors, classes, required }">
                                <div class="form-group">
                                    <label for="register_email" class="register-label">E-mail<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                    <div>
                                        <b-button id="tooltip-email" class="register-tooltip-btn">
                                            <b-icon icon="info-circle-fill"></b-icon>
                                        </b-button>
                                        <b-tooltip target="tooltip-email" triggers="hover" custom-class="register-tooltip-text">
                                            Dado de contato e acesso.
                                        </b-tooltip>
                                    </div>
                                    <input type="email" id="register_email" name="register_email" class="form-control register-input-field font-italic" v-model="person.email" :class="classes">
                                    <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="col-sm-6 col-lg-3">
                            <ValidationProvider name="repita o e-mail" rules="required|email|confirmed:email" slim v-slot="{ errors, classes, required }">
                                <div class="form-group">
                                    <label for="register_confirm_email" class="register-label">Repita o e-mail<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                    <div>
                                        <b-button id="tooltip-email-confirm" class="register-tooltip-btn">
                                            <b-icon icon="info-circle-fill"></b-icon>
                                        </b-button>
                                        <b-tooltip target="tooltip-email-confirm" triggers="hover" custom-class="register-tooltip-text">
                                            Dado de contato e acesso.
                                        </b-tooltip>
                                    </div>
                                    <input type="email" id="register_confirm_email" name="register_confirm_email" class="form-control register-input-field font-italic" v-model="person.conf_email" :class="classes">
                                    <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="col-sm-6 col-lg-3">
                            <ValidationProvider name="senha" rules="required|password" vid="password" slim v-slot="{ errors, classes, required }">
                                <div class="form-group">
                                    <label for="register_password" class="register-label">Senha<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                    <InputPassword id="register_password" :classes="classes" v-model="person.password" autocomplete="new-password"/>
                                    <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="col-sm-6 col-lg-3">
                            <ValidationProvider name="repita a senha" rules="required|confirmed:password" slim v-slot="{ errors, classes, required }">
                                <div class="form-group">
                                    <label for="register_confirm_password" class="register-label">Repita a senha<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                    <InputPassword id="register_confirm_password" :classes="classes" v-model="person.conf_password"/>
                                    <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </div>
                            </ValidationProvider>
                        </div>
                    </b-row>
                </fieldset>
                <fieldset class="mt-3">
                    <div class="row">
                        <template v-if="person.type === 'PF'">
                            <legend class="col-12 register-data-title">Dados pessoais</legend>
                            <div class="col-sm-6 col-lg-6 col-xl-5">
                                <ValidationProvider name="nome completo" rules="required|fullname" slim v-slot="{ errors, classes, required }">
                                    <div class="form-group">
                                        <label for="register_name" class="register-label">Nome completo<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                        <input type="text" id="register_name" name="register_name" class="form-control register-input-field" v-model="person.name" :class="classes">
                                        <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="col-sm-6 col-lg-3">
                                <ValidationProvider name="CPF" rules="required|cpf" slim v-slot="{ errors, classes, required }">
                                    <div class="form-group">
                                        <label for="register_cpf" class="register-label">CPF<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                        <div>
                                            <b-button id="tooltip-cpf" class="register-tooltip-btn">
                                                <b-icon icon="info-circle-fill"></b-icon>
                                            </b-button>
                                            <b-tooltip target="tooltip-cpf" triggers="hover" custom-class="register-tooltip-text">
                                                Necessário para nota fiscal.
                                            </b-tooltip>
                                        </div>
                                        <the-mask type="tel" inputmode="numeric" id="register_cpf" name="register_cpf" class="form-control register-input-field" v-model="person.cpf" :class="classes" :mask="['###.###.###-##']" :masked="true"/>
                                        <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="col-sm-6 col-lg-3 col-xl-2">
                                <ValidationProvider name="data de nascimento" rules="required|dateage" slim v-slot="{ errors, classes, required }">
                                    <div class="form-group">
                                        <label for="register_birthdate" class="register-label">Data de nascimento<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                        <div>
                                            <b-button id="tooltip-birthdate" class="register-tooltip-btn">
                                                <b-icon icon="info-circle-fill"></b-icon>
                                            </b-button>
                                            <b-tooltip target="tooltip-birthdate" triggers="hover" custom-class="register-tooltip-text">
                                                Para validar a idade.
                                            </b-tooltip>
                                        </div>
                                        <the-mask type="text" id="register_birthdate" name="register_birthdate" class="form-control register-input-field" v-model="person.birthdate" :class="classes" :mask="['##/##/####']" :masked="true"/>
                                        <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="col-sm-6 col-lg-2">
                                <ValidationProvider name="sexo" rules="required" slim v-slot="{ errors, classes, required }">
                                    <div class="form-group">
                                        <label for="register_gender" class="register-label">Sexo<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                        <select id="register_gender" name="register_gender" class="form-control register-input-field" v-model="person.gender" :value="person.gender" :class="classes">
                                            <option value="F">Feminíno</option>
                                            <option value="M">Masculino</option>
                                            <option value="X">Não informar</option>
                                        </select>
                                        <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                    </div>
                                </ValidationProvider>
                            </div>
                        </template>
                        <template v-if="person.type === 'PJ'">
                            <legend class="col-12">Dados empresariais</legend>
                            <div class="col-sm-6 col-lg-5">
                                <ValidationProvider name="razão social" rules="required|fullname" slim v-slot="{ errors, classes, required }">
                                    <div class="form-group">
                                        <label for="razao_social" class="register-label">Razão social<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                        <input type="text" class="form-control register-input-field" id="razao_social" name="razao_social" v-model="person.razao_social" :class="classes">
                                        <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="col-sm-6 col-lg-4">
                                <ValidationProvider name="nome fantasia" rules="required" slim v-slot="{ errors, classes, required }">
                                    <div class="form-group">
                                        <label for="nome_fantasia" class="register-label">Nome fantasia<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                        <input type="text" class="form-control register-input-field" id="nome_fantasia" name="nome_fantasia" v-model="person.nome_fantasia" :class="classes">
                                        <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="col-sm-6 col-lg-3">
                                <ValidationProvider name="CNPJ" rules="required|cnpj" slim v-slot="{ errors, classes, required }">
                                    <div class="form-group">
                                        <label for="cnpj" class="register-label">CNPJ<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                        <div>
                                            <b-button id="tooltip-cnpj" class="register-tooltip-btn">
                                                <b-icon icon="info-circle-fill"></b-icon>
                                            </b-button>
                                            <b-tooltip target="tooltip-cnpj" triggers="hover" custom-class="register-tooltip-text">
                                                Necessário para nota fiscal.
                                            </b-tooltip>
                                        </div>
                                        <the-mask type="text" class="form-control register-input-field" id="cnpj" name="cnpj" v-model="person.cnpj" :class="classes" :mask="['##.###.###/####-##']" :masked="true" inputmode="numeric"/>
                                        <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="col-sm-6 col-lg-3">
                                <ValidationProvider name="inscrição estadual" rules="" slim v-slot="{ errors, classes, required }">
                                    <div class="form-group">
                                        <label for="insc_estadual" class="register-label">Inscrição estadual<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                        <input type="text" class="form-control register-input-field" id="insc_estadual" name="insc_estadual" v-model="person.insc_estadual" :class="classes">
                                        <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="col-sm-6 col-lg-3">
                                <ValidationProvider name="inscrição municipal" rules="required" slim v-slot="{ errors, classes, required }">
                                    <div class="form-group">
                                        <label for="insc_municipal" class="register-label">Inscrição municipal<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                        <input type="text" class="form-control register-input-field" id="insc_municipal" name="insc_municipal" v-model="person.insc_municipal" :class="classes">
                                        <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                    </div>
                                </ValidationProvider>
                            </div>
                        </template>
                        <div class="col-sm-6 col-lg-3">
                            <ValidationProvider name="telefone" :rules="{ required: true, regex: /^\(?\d{2}\)?[\s-]?[\s9]?\d{4}-?\d{4}$/ }" slim v-slot="{ errors, classes, required }">
                                <div class="form-group">
                                    <label for="register_phone" class="register-label">Telefone<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                    <div>
                                        <b-button id="tooltip-phone" class="register-tooltip-btn">
                                            <b-icon icon="info-circle-fill"></b-icon>
                                        </b-button>
                                        <b-tooltip target="tooltip-phone" triggers="hover" custom-class="register-tooltip-text">
                                            Para dado de contato.
                                        </b-tooltip>
                                    </div>
                                    <the-mask type="tel" inputmode="numeric" id="register_phone" name="register_phone" class="form-control register-input-field" v-model="person.phone" :class="classes" :mask="['(##) ####-####', '(##) #####-####']" :masked="true"/>
                                    <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="col-sm-6 col-lg-3">
                            <ValidationProvider name="celular" rules="" slim v-slot="{ errors, classes, required }">
                                <div class="form-group">
                                    <label for="register_cellphone" class="register-label">Celular</label>
                                    <the-mask type="tel" inputmode="numeric" id="register_cellphone" name="register_cellphone" class="form-control register-input-field" v-model="person.cellphone" :class="classes" :mask="['(##) ####-####', '(##) #####-####']" :masked="true"/>
                                    <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </div>
                            </ValidationProvider>
                        </div>
                    </div>
                </fieldset>
                <fieldset class="mt-3">
                    <div class="row">
                        <div class="col-sm-6 col-lg-2">
                            <ValidationProvider name="CEP" :rules="{ required: true, regex: /^\d{5}-?\d{3}$/ }" slim v-slot="{ errors, classes, required }">
                                <div class="form-group">
                                    <div class="d-flex justify-content-between">
                                        <label for="register_cep" class="register-label">CEP<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                        <small><a href="http://www.buscacep.correios.com.br/sistemas/buscacep/buscaCepEndereco.cfm" title="Não sabe?" class="register-forget">Não sabe?</a></small>
                                    </div>
                                    <the-mask type="tel" inputmode="numeric" id="register_cep" name="register_cep" class="form-control register-input-field" v-model="address.cep" :class="classes" :mask="['#####-###']" :masked="true"/>
                                    <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="col-sm-6 col-lg-5">
                            <ValidationProvider name="endereço" rules="required" slim v-slot="{ errors, classes, required }">
                                <div class="form-group">
                                    <label for="register_address" class="register-label">Endereço<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                    <input type="text" id="register_address" name="register_address" class="form-control register-input-field" v-model="address.street" :class="classes">
                                    <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="col-sm-6 col-lg-2">
                            <ValidationProvider name="número" rules="required" slim v-slot="{ errors, classes, required }">
                                <div class="form-group">
                                    <label for="register_addressNumber" class="register-label">N&deg;<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                    <input type="tel" inputmode="numeric" id="register_addressNumber" name="register_addressNumber" class="form-control register-input-field" v-model="address.number" :class="classes">
                                    <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="col-sm-6 col-lg-3">
                            <ValidationProvider name="complemento" rules="" slim v-slot="{ errors, classes, required }">
                                <div class="form-group">
                                    <label for="register_addressComplement" class="register-label">Complemento<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                    <input type="text" id="register_addressComplement" name="register_addressComplement" class="form-control register-input-field" v-model="address.complement" :class="classes">
                                    <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="col-sm-6 col-lg-3">
                            <ValidationProvider name="bairro" rules="required" slim v-slot="{ errors, classes, required }">
                                <div class="form-group">
                                    <label for="register_addressNeighbourhood" class="register-label">Bairro<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                    <input type="text" id="register_addressNeighbourhood" name="register_addressNeighbourhood" class="form-control register-input-field" v-model="address.neighborhood" :class="classes">
                                    <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="col-sm-6 col-lg-3">
                            <ValidationProvider name="cidade" rules="required" slim v-slot="{ errors, classes, required }">
                                <div class="form-group">
                                    <label for="register_addressCity" class="register-label">Cidade<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                    <input type="text" id="register_addressCity" name="register_addressCity" class="form-control register-input-field" v-model="address.city" :class="classes">
                                    <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="col-sm-6 col-lg-3">
                            <ValidationProvider name="UF" rules="required" slim v-slot="{ errors, classes, required }">
                                <div class="form-group">
                                    <label for="register_addressState" class="register-label">UF<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                    <select id="register_addressState" name="register_addressState" class="form-control register-input-field" v-model="address.state" :value="address.state" :class="classes">
                                        <option value="AC">Acre</option>
                                        <option value="AL">Alagoas</option>
                                        <option value="AP">Amapá</option>
                                        <option value="AM">Amazonas</option>
                                        <option value="BA">Bahia</option>
                                        <option value="CE">Ceará</option>
                                        <option value="DF">Distrito Federal</option>
                                        <option value="ES">Espírito Santo</option>
                                        <option value="GO">Goiás</option>
                                        <option value="MA">Maranhão</option>
                                        <option value="MT">Mato Grosso</option>
                                        <option value="MS">Mato Grosso do Sul</option>
                                        <option value="MG">Minas Gerais</option>
                                        <option value="PA">Pará</option>
                                        <option value="PB">Paraíba</option>
                                        <option value="PR">Paraná</option>
                                        <option value="PE">Pernambuco</option>
                                        <option value="PI">Piauí</option>
                                        <option value="RJ">Rio de Janeiro</option>
                                        <option value="RN">Rio Grande do Norte</option>
                                        <option value="RS">Rio Grande do Sul</option>
                                        <option value="RO">Rondônia</option>
                                        <option value="RR">Roraima</option>
                                        <option value="SC">Santa Catarina</option>
                                        <option value="SP">São Paulo</option>
                                        <option value="SE">Sergipe</option>
                                        <option value="TO">Tocantins</option>
                                    </select>
                                    <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="col-sm-6 col-lg-3">
                            <ValidationProvider name="país" rules="required" slim v-slot="{ errors, classes, required }">
                                <div class="form-group">
                                    <label for="register_addressCountry" class="register-label">País<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                    <input type="text" id="register_addressCountry" name="register_addressCountry" class="form-control register-input-field" v-model="address.country" :class="classes">
                                    <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </div>
                            </ValidationProvider>
                        </div>
                    </div>
                </fieldset>
                <div class="mt-4 mb-2">
                    <ValidationProvider name="política de privacidade" rules="required" slim v-slot="{ errors, classes, required }">
                        <div class="register-form-check">
                            <input class="register-form-check-input" type="checkbox" id="defaultCheck1" v-model="person.terms" :class="classes">
                            <label class="register-form-check-label" for="defaultCheck1">
                                Li e aceito os
                                <a href="/central-de-atendimento/termo-de-privacidade/" title="Política de privacidade">Política de Privacidade</a>.
                            </label>
                        </div>
                    </ValidationProvider>
                </div>
                <recaptcha :data-sitekey="$wdconfig.default.recaptcha_site"/>
                <FormMessage :msg="msg_form" :type="msg_form_type"></FormMessage>
                <div class="d-flex justify-content-end mb-5">
                    <button type="submit" class="btn-default btn-square" :disabled="sending">
                        {{ sending ? 'Enviando' : 'CADASTRE-SE' }}
                    </button>
                </div>
            </form>
        </ValidationObserver>
    </b-row>
</template>
<script>
import {ValidationProvider, ValidationObserver} from "vee-validate";
import {TheMask} from "vue-the-mask";
import FormMessage from "~/components/FormMessage";
import InputPassword from "~/components/Input-password.vue";

const Cookie = process.client ? require('js-cookie') : undefined

export default {
    components: {
        FormMessage,
        ValidationProvider,
        ValidationObserver,
        TheMask,
        InputPassword
    },
    data: () => {
        return {
            msg_form: '',
            msg_form_type: '',
            sending: false,
            token: "",
            person: {
                email: '',
                conf_email: '',
                password: '',
                conf_password: '',
                type: 'PF',
                name: '',
                cpf: '',
                gender: '',
                birthdate: '',
                razao_social: '',
                nome_fantasia: '',
                cnpj: '',
                insc_estadual: '',
                insc_municipal: '',
                phone: '',
                cellphone: '',
            },
            address: {
                cep: '',
                street: '',
                number: '',
                complement: '',
                neighborhood: '',
                city: '',
                uf: '',
                country: ''
            },
        }
    },
    mounted() {
        this.person.name = sessionStorage.getItem('register_name');
        this.person.email = sessionStorage.getItem('register_email');
        this.person.phone = sessionStorage.getItem('register_telefone');
    },
    methods: {
        async onSubmit() {
            try {
                this.sending = true;
                const params = new URLSearchParams();
                this.token = await this.$recaptcha.getResponse();
                params.append('g-recaptcha-response', this.token);
                if (this.person.type === 'PF') {
                    params.append('nome', this.person.name)
                    params.append('cpf', this.person.cpf)
                    params.append('sexo', this.person.gender)
                    params.append('data_nascimento', this.person.birthdate)
                } else {
                    params.append('razao_social', this.person.razao_social)
                    params.append('nome', this.person.nome_fantasia)
                    params.append('cnpj', this.person.cnpj)
                    params.append('inscestadual', this.person.insc_estadual)
                    params.append('inscmunicipal', this.person.insc_municipal)
                }
                params.append('tipo_pessoa', this.person.type)
                params.append('email', this.person.email)
                params.append('senha', this.person.password)
                params.append('telefone', this.person.phone)
                params.append('celular', this.person.cellphone)

                params.append('cep', this.address.cep)
                params.append('endereco', this.address.street)
                params.append('numero', this.address.number)
                params.append('referencia', this.address.complement)
                params.append('bairro', this.address.neighborhood)
                params.append('cidade', this.address.city)
                params.append('uf', this.address.state)
                params.append('pais', this.address.country)
                // params.append('', 'nome_contato')
                // params.append('', 'telefone_contato')
                // params.append('', 'email_contato')
                params.append('metodo', 'register_person')
                params.append('adicionarusuario', 'sim')
                params.append('autologin', 'sim')
                params.append('type_project', 'site')
                params.append('jwt', 'yes')
                return this.$axios.$post('?p=erp_pessoas_api_v1', params)
                    .then((response) => {
                        let firstname = this.person.name.split(' ')
                        if (response.status === 'sucesso') {
                            const auth = {
                                access_token: response.jwt,
                                person_name: this.person.name,
                                firstname: firstname[0]
                            }
                            this.$store.commit('setAuth', auth)
                            Cookie.set('auth', auth, {path: '/'})
                            if (this.$route.query.next) {
                                this.$router.push(this.$route.query.next)
                            } else {
                                this.$router.push('/cadastro/confirmacao')
                            }
                        } else {
                            this.$recaptcha.reset();
                            this.msg_form = 'Erro ao cadastrar: ' + response.msg.replace(':', '');
                            this.msg_form_type = 'error';
                        }
                    });
            } catch (e) {
                console.error(e)
                await this.$recaptcha.reset();
                this.msg_form = 'Não foi possível registar';
                this.msg_form_type = 'error';
            }
        },
        getCep: function (cep) {
            if (cep === undefined) {
                return;
            }
            cep = cep.replace(/\D+/g, "");
            if (cep.length !== 8) {
                return;
            }
            const params = new URLSearchParams();
            params.append('cep', cep);
            this.$axios.$post('/cep.php', params)
                .then((data) => {
                    if (data.tipo !== 'sucesso') {
                        throw data.msg;
                    }
                    this.address.street = (data.dados.tipo_logradouro + ' ' + data.dados.logradouro).trim();
                    this.address.neighborhood = (data.dados.bairro).trim();
                    this.address.city = (data.dados.cidade).trim();
                    this.address.state = (data.dados.uf).toUpperCase().trim();
                    this.address.country = 'Brasil';
                })
                .catch(function (e) {
                    console.error(e);
                });
        }
    },
    watch: {
        'address.cep'(newvalue) {
            this.getCep(newvalue);
        },
        sending(newvalue) {
            if (newvalue) {
                this.msg_form = ''
            }
        },
        msg_form(newvalue) {
            if (newvalue !== '') {
                this.sending = false
            }
        }
    }
};
</script>
